import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import RegisterProgressBar from '../../RegisterProgressBar';
import LoginRegisterTabs from '../../LoginRegisterTabs';
import Button from "@material-ui/core/Button";
import { Link, Link as RouterLink } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import { Controller, useForm } from "react-hook-form";

import {
  makeStyles,
} from "@material-ui/core";


const useStylesAll = makeStyles(theme => ({
  pageContainer: {
    position: "absolute",
    width: "100%",
    fontFamily: "Poppins",
  },
  container: {
    width: "85%",
    backgroundColor: '#FFFFFF',
    margin: "30px auto",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up('md')]: {
      margin: "20vh auto",
      width: 625,
      padding: "30px",
    },
    '@media (max-height:750px)': {
      marginTop: '180px',
    }
  },
  btn: {
    marginTop: "30px",
    [theme.breakpoints.up('md')]: {
      marginTop: "40px",
    },
  },
  highlight: {
    color: "#962013",
    textDecoration: "none",
  },
}));

function FormLayout(props) {
  const { children, currentStep, next, prev, goto, confirm, isRenew } = props;
  const { t, i18n } = useTranslation('register');
  const classes = useStylesAll();
  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({
  });

  function NextButton() {
    const { currentStep, next, confirm } = props;
    // If the current step is not 6, then render the "next" button
    if (currentStep < 5) {
      return (
        <Button type="submit" className={classes.btn} variant="contained" fullWidth onClick={next}>{t('next')}</Button>
      )
    } else if (currentStep == 5) {
      return (
        <Button type="submit" className={classes.btn} variant="contained" fullWidth onClick={confirm}>{t('confirm')}</Button>
      )
    }
    // ...else render nothing
    return null;
  }

  function PrevButton() {
    const { currentStep, prev } = props;
    if (currentStep < 7) {
      return (
        <Button type="submit" className={classes.btn} variant="contained" fullWidth onClick={prev}>{t('prev')}</Button>
      )
    }
    // ...else render nothing
    return null;
  }

  function GotoButton() {
    const { currentStep, goto } = props;
    return (
      <Button type="submit" className={classes.btn} variant="contained" fullWidth onClick={goto}>{t('goto')}</Button>
    )
  }

  return (
    <Box className={classes.pageContainer}>
      <Box className={classes.container}>
      {currentStep > 0 ?

        <Grid container spacing={1}>
          <Grid item xs={12}>
            {!isRenew ? <LoginRegisterTabs active="register" /> : <></>}
            <Typography variant="h1">{!isRenew ? t('title') : t('renewtitle')}</Typography>
          </Grid>
          <RegisterProgressBar step={currentStep} />
          {children}
          <NextButton currentStep={currentStep} next={next} confirm={confirm} />
          <PrevButton currentStep={currentStep} prev={prev} />
          {currentStep == 1 && !isRenew?
            <Grid item xs={12}>
              <Typography variant="body1" align="center" gutterBottom="true"><Link className={classes.highlight} to={`/${i18n.language}/login`}>{t('login')}</Link> </Typography>
            </Grid>
            : <></>}
        </Grid>
      :
        <>
        {children}
        <NextButton currentStep={currentStep} next={next} />
        {!isRenew &&
        <Grid item xs={12}>
          <Typography variant="body1" align="center" gutterBottom="true"><Link className={classes.highlight} to={`/${i18n.language}/login`}>{t('login')}</Link> </Typography>
        </Grid>
        }
        </>
      
      }
      </Box>
    </Box>
  );
}

export default FormLayout;
